import React from 'react';
import clsx from 'clsx';
import { Icons } from '../../Icons/Icons';

interface ActionMenuContentProps {
  openMenu: boolean;
  menuPosition: { top: number; left: number };
  onEdit?: () => void;
  onDelete?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  actions?: {
    label: string;
    icon: React.ReactNode;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
  }[];
  handleMenuToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleActionClick: (
    e: React.MouseEvent<HTMLButtonElement>,
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  ) => void;
}

export const ActionMenuContent: React.FC<ActionMenuContentProps> = ({
  openMenu,
  menuPosition,
  onEdit,
  onDelete,
  actions,
  handleMenuToggle,
  handleActionClick,
}) => {
  return (
    <div
      className={clsx('card-menu', { open: openMenu })}
      style={{
        top: menuPosition.top,
        left: menuPosition.left,
      }}
    >
      {onEdit && (
        <button
          className="edit-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onEdit();
            handleMenuToggle(e);
          }}
        >
          {Icons.Edit} Edit
        </button>
      )}
      {onDelete && (
        <button className="delete-button" onClick={onDelete}>
          {Icons.Delete} Delete
        </button>
      )}
      {actions?.map((action, index) => (
        <button
          key={index}
          className={action.className}
          onClick={(e) => handleActionClick(e, action.onClick)}
        >
          {action.icon} {action.label}
        </button>
      ))}
    </div>
  );
};
